import { h } from "hyperapp";

import listCSS from "./list.css";

import { addressRenderer } from "../../common/address-renderer/address-renderer";
import { columnIsSelected } from "../../common/column-selector/utils/column-is-selected";
import { contactRenderer } from "../../common/contact-renderer/contact-renderer";
import { areAllSelected } from "../../common/list-item-selector/utils/are-all-selected";

export const list = ({ actions, section, state }): JSX.Element => {
  const { setAllSelected, setSelected } = actions;
  const { categories } = state;

  const { columns, items, selected } = state[section];

  return (
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class={listCSS.singleIconColumn} scope="col">
              <div class="custom-control custom-checkbox">
                <input
                  class="custom-control-input"
                  checked={areAllSelected({ items, selected })}
                  disabled={items.length === 0}
                  id="selectAllItemsOnCurrentPage"
                  onchange={event =>
                    setAllSelected({ section, select: event.target.checked })
                  }
                  type="checkbox"
                />
                <label
                  class="custom-control-label"
                  for="selectAllItemsOnCurrentPage"
                />
              </div>
            </th>
            <th scope="col">Nome</th>
            {columnIsSelected({ columnID: "address", columns }) && (
              <th scope="col">Endereço</th>
            )}
            {columnIsSelected({ columnID: "category", columns }) && (
              <th scope="col">Categoria</th>
            )}
            {columnIsSelected({ columnID: "cnpj_cpf", columns }) && (
              <th scope="col">CNPJ</th>
            )}
            {columnIsSelected({ columnID: "last_visit", columns }) && (
              <th scope="col">Última Visita</th>
            )}
            {columnIsSelected({ columnID: "contacts", columns }) && (
              <th scope="col">Contato</th>
            )}
            {columnIsSelected({ columnID: "corporate_name", columns }) && (
              <th scope="col">Razão Social</th>
            )}
            {columnIsSelected({ columnID: "status", columns }) && (
              <th scope="col">Status</th>
            )}
            {columnIsSelected({ columnID: "id", columns }) && (
              <th scope="col">ID</th>
            )}
          </tr>
        </thead>
        <tbody>
          {items.map(
            ({
              address,
              category_id: categoryID,
              cnpj_cpf: cnpjCPF,
              contacts,
              corporate_name: corporateName,
              id,
              name,
              status,
            }) => {
              const category = categories.find(
                category => category.id === categoryID,
              );

              const isSelected =
                selected.findIndex(item => item.id === id) !== -1;

              return (
                <tr
                  class={isSelected ? "table-info" : ""}
                  onclick={() =>
                    setSelected({
                      section,
                      select: !isSelected,
                      value: id,
                    })
                  }
                  style="cursor: pointer;"
                >
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input
                        checked={isSelected}
                        class="custom-control-input"
                        id={id}
                        onchange={() =>
                          setSelected({
                            section,
                            select: !isSelected,
                            value: id,
                          })
                        }
                        type="checkbox"
                        value={id}
                      />
                      <label class="custom-control-label" for={id} />
                    </div>
                  </td>
                  <th scope="row">{name}</th>
                  {columnIsSelected({ columnID: "address", columns }) &&
                    (address ? (
                      <td>{addressRenderer({ address })}</td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <i>Sem endereço</i>
                      </td>
                    ))}
                  {columnIsSelected({ columnID: "category", columns }) &&
                    (category ? (
                      <td>{category.name}</td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <i>Não categorizado</i>
                      </td>
                    ))}
                  {columnIsSelected({ columnID: "cnpj_cpf", columns }) && (
                    <td style="white-space: nowrap;">{cnpjCPF}</td>
                  )}
                  {columnIsSelected({ columnID: "contacts", columns }) &&
                    (contacts ? (
                      <td>{contactRenderer({ contacts })}</td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <i>Sem contato</i>
                      </td>
                    ))}
                  {columnIsSelected({
                    columnID: "corporate_name",
                    columns,
                  }) && <td>{corporateName}</td>}
                  {columnIsSelected({ columnID: "status", columns }) && (
                    <td>{state.possiblePlaceStatuses[state.locale][status]}</td>
                  )}
                  <td>
                    {columnIsSelected({ columnID: "id", columns }) && (
                      <span class={listCSS.uuid}>{id}</span>
                    )}
                  </td>
                </tr>
              );
            },
          )}
        </tbody>
      </table>
    </div>
  );
};
